<template>
  <div>
    <b-modal
      id="fleetioVehiclesModal"
      size="xl"
      content-class="menu-bg-blue-transparent-modal fleetio-modal"
      body-class="scroll-Container"
      title="Acquisition Vehicles"
      hide-footer
     
      scrollable
      @show="loadVehicles()"
    >
      <!-- Fleetio Vehicles Table -->
        <div class="d-flex justify-content-center align-items-center py-1" v-if="fleetioVehiclesSpinner">
      <span class="spinner-border spinner-border-md highlightLoader" role="status" aria-hidden="true"></span>
      <span class="highlightLoader p-1 spinner-border-md">Loading Data...</span>
    </div>
      <div v-else>
        <div class="tableHeader">
          <b-form-checkbox-group class="checkboxes" v-model="selectedRegions">
            <b-form-checkbox size="lg" value="North America">NA</b-form-checkbox>
            <b-form-checkbox size="lg" value="Europe">EU</b-form-checkbox>
            <b-form-checkbox size="lg" value="Japan">JP</b-form-checkbox>
            <b-form-checkbox size="lg" value="Middle East">ME</b-form-checkbox>
          </b-form-checkbox-group>
        </div>
        <vue-bootstrap4-table
          :rows="fleetioVehicles.filter(vehicle => selectedRegions.includes(vehicle.group_name))"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="zoomToFeature($event)"
        ></vue-bootstrap4-table>
      </div>
    </b-modal>
  </div>
</template>

<style>
.fleetio-modal .menu-bg-blue-transparent,
.fleetio-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.fleetio-modal table { color: #063c6d !important; text-shadow: none !important; }
.fleetio-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.fleetio-modal thead th a,
.fleetio-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.fleetio-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.fleetio-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.fleetio-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.fleetio-modal .footer-pagination-row td,
.fleetio-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
</style>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'
export default {
  name: 'MMP_FleetioVehicles',
  components: {
    VueBootstrap4Table
  },
  props: ['extent'],
  data() {
    return {
      classes: {
        table: {
          'menu-bg-blue-transparent': true
        }
      },
      columns: [
        {
          label: 'Vehicle',
          name: 'name',
          sort: true
        },
        {
          label: 'Status',
          name: 'vehicle_status_name',
          sort: true
        }
      ],
      config: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        per_page: 10,
        show_refresh_button: false,
        show_reset_button: false
      },
      fleetioVehicles: [],
      fleetioVehiclesSpinner: false,
      selectedRegions: ['North America', 'Europe', 'Japan', 'Middle East']
    }
  },
  methods: {
    getFleetioVehicles: async function(extent) {
      if (sessionStorage.token) {
        let vehicles = await axios
          .get(process.env.API_LOCATION + '/api/fleetio/getAllVehicles', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              extent: extent
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getAllVehicles API Call Error: ' + content.errors)
            } else {
              return content
            }
          })
          .catch(function (error) {
            this.fleetioVehiclesSpinner = false
            return []
          })
        return vehicles
      } else {
        console.log('No User Token')
        this.$router.push({name: 'Login'})
      }
    },
    async getAllVehicles() {
      if (sessionStorage.token) {
        try {
          this.fleetioVehiclesSpinner = true
          this.fleetioVehicles = []
          const [naVehicles, euVehicles, jpVehicles, meVehicles] = await Promise.all([
            this.getFleetioVehicles('North America'),
            this.getFleetioVehicles('Europe'),
            this.getFleetioVehicles('Japan'),
            this.getFleetioVehicles('Middle East')
          ]);
          this.fleetioVehicles = [
            ...naVehicles,
            ...euVehicles,
            ...jpVehicles,
            ...meVehicles
          ];
          this.fleetioVehiclesSpinner = false
        } catch (err) {
          console.log(err)
          this.$router.push({name: 'Login'})
        }
      } else {
        console.log('No User Token')
      }
    },
    loadVehicles() {
      this.$nextTick(() => {
        this.getAllVehicles()
      })
    },
    async zoomToFeature(row) {
      let newExtent = row.selected_item.group_name
      let vehicleName = row.selected_item.name
      let vehicleStatus = row.selected_item.vehicle_status_name

      if (vehicleStatus != 'Collecting' && vehicleStatus != 'Not Collecting') {
        let msg = 'Vehicle selected is not available right now. Please select a vehicle with status Collecting or Not Collecting'
        this.$bvToast.toast(msg, {
          autoHideDelay: 10000,
          variant: 'danger',
          solid: true,
          title: 'Vehicle Unavailable',
          toaster: 'b-toaster-top-center'
        })
      } else {
        this.$emit('vehicleSelected', { vehicleName, newExtent })
      }
    }
  },
}
</script>
